module.exports = __webpack_public_path__ + "static/media/om.67bf19bd.svg";